const Tdata = [
    {
      id: 1,
      desc:
        "I have always struggled with my health until Solomon's Haven helped me with a free medical consultation which allowed me to have a proper checkup.",
      name: "OSAS AIMIWU",
      profile: "/images/profile/profile1.jpeg",
      post: "Beneficiary",
    },
    {
      id: 2,
      desc:
        "Solomon's Haven has been a great support for our community. Their dedication to helping women and children is truly inspiring. Keep up the good work!",
      name: "JOEL MARVEL",
      profile: "/images/profile/profile2.jpeg",
      post: "Beneficiary",
    },
    {
      id: 3,
      desc:
        "I've witnessed the positive impact of Solomon's Haven in various regions. Their commitment to education and healthcare is changing lives for the better.",
      name: "FRANCA IDEMUDIA",
      profile: "/images/profile/profile3.jpeg",
      post: "Beneficiary",
    },
    {
      id: 4,
      desc:
        "Solomon's Haven is not just an organization; it's a ray of hope for many. The work they do is remarkable, and I'm proud to be associated with them.",
      name: "BLESSING OSAMUDAIMEN",
      profile: "/images/profile/profile4.jpeg",
      post: "Beneficiary",
    },
    {
      id: 5,
      desc:
        "I'm amazed by the dedication and passion of the team at Solomon's Haven. Their efforts in making the world a better place are truly commendable.",
      name: "AHMED HARUNA",
      profile: "/images/profile/profile5.jpeg",
      post: "SPONSOR",
    },
    {
      id: 6,
      desc:
        "Solomon's Haven's founder, is a blessing and the organization leader is a true visionary. Her leadership has brought about positive change and empowered countless lives.",
      name: "MEGAN JULLIET",
      profile: "/images/profile/images.jpeg",
      post: "Beneficiary",
    },
  ];
  
  export default Tdata;
  